{
  "Accessibility Menu": "Tilgængelighedsmenu",
  "Reset settings": "Nulstil indstillinger",
  "Close": "Luk",
  "Content Adjustments": "Justeringer af indhold",
  "Adjust Font Size": "Juster skriftstørrelse",
  "Highlight Title": "Fremhæv titel",
  "Highlight Links": "Fremhæv links",
  "Readable Font": "Læsbar skrifttype",
  "Color Adjustments": "Farvejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høj kontrast",
  "High Saturation": "Høj mætning",
  "Low Saturation": "Lav mætning",
  "Monochrome": "Monokrom",
  "Contrast": "Kontrast",
  "Invert Colors": "Invertér farver",
  "Tools": "Værktøjer",
  "Reading Guide": "Læsevejledning",
  "Stop Animations": "Stop animationer",
  "Big Cursor": "Stor markør",
  "Increase Font Size": "Øg skriftstørrelse",
  "Decrease Font Size": "Mindsk skriftstørrelse",
  "Letter Spacing": "Bogstavafstand",
  "Line Height": "Linjehøjde",
  "Font Weight": "Skrifttypevægt",
  "Dyslexia Font": "Ordblinde-skrifttype",
  "Language": "Sprog",
  "Open Accessibility Menu": "Åbn tilgængelighedsmenu",
  "Widget Settings": "Widget-indstillinger",
  "Widget Position": "Widget-position",
  "Top Left": "Øverst til venstre",
  "Top Center": "Øverst i midten",
  "Top Right": "Øverst til højre",
  "Center Left": "Midten til venstre",
  "Center Right": "Midten til højre",
  "Bottom Left": "Nederst til venstre",
  "Bottom Center": "Nederst i midten",
  "Bottom Right": "Nederst til højre",
  "Screen Reader": "Skærmlæser",
  "Voice Navigation": "Stemmenavigation",
  "Custom Color": "Tilpasset farve",
  "Change the site's colors": "Skift webstedets farver",
  "Backgrounds": "Baggrunde",
  "Headings": "Overskrifter",
  "Contents": "Indhold",
  "Reset colors": "Nulstil farver",
  "Image Desaturation": "Billed-desaturering",
  "Search languages": "Søg efter sprog",
  "No languages found": "Ingen sprog fundet",
  "Accessibility Profiles": "Tilgængelighedsprofiler",
  "Motor Impaired": "Motorisk handicap",
  "Big cursor, voice navigation, and no animations.": "Stor markør, stemmestyring og ingen animationer.",
  "Blind": "Blind",
  "Screen reader helpers with higher contrast.": "Skærmlæserhjælp med højere kontrast.",
  "Color Blind": "Farveblind",
  "High contrast palette with desaturated media.": "Palette med høj kontrast og dæmpede medier.",
  "Dyslexia": "Dysleksi",
  "Friendly font, extra spacing, stronger weight.": "Letlæselig skrifttype, ekstra afstand og kraftigere vægt.",
  "Low vision": "Nedsat syn",
  "Dark contrast and 130% magnification.": "Mørk kontrast og 130 % forstørrelse.",
  "Cognitive & Learning": "Kognitivt og læring",
  "Highlights key sections and enables voice help.": "Fremhæver nøglesektioner og aktiverer stemmehjælp.",
  "Seizure & Epileptic": "Anfald og epilepsi",
  "Stops animations and desaturates imagery.": "Stopper animationer og dæmper billeder.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Læsevejledning, fremhævede links og roligere farver.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
